<template>
	<div>
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%;">
					<a-row type="flex" justify="space-between">
						<a-col span="12">
							<a-button type="primary" @click="$refs.addForm._show()">添加计划</a-button>
						</a-col>
						<a-col span="12">
							<a-row type="flex" align="middle" justify="end" :gutter="3">
								<a-col span="12">
									<a-input v-model="param.keyword" allowClear search @pressEnter="getList()"
										@change="change" @on-clear="getList()" placeholder="关键词查询"></a-input>
								</a-col>

								<a-col span="6" v-if="getOrganId() <= 10000">
									<a-select v-model="param.organId" style="width:100%" @change="e => {
										filterOrgan(e);
										this.getList();
									}
										" placeholder="根据单位筛选">
										<a-select-option value="">所有单位</a-select-option>
										<a-select-option :value="organ.organId" v-for="(organ, index) in organList"
											:key="index">{{ organ.name
											}}</a-select-option>
									</a-select>
								</a-col>
								<a-col span="6">
									<a-select v-model="param.status" style="width:100%" @change="e => {
										this.getList();
									}
										" placeholder="根据状态类型进行筛选">
										<a-select-option value="">所有</a-select-option>
										<a-select-option value="未开始">未开始</a-select-option>
										<a-select-option value="进行中">进行中</a-select-option>
										<a-select-option value="已完成">已完成</a-select-option>
									</a-select>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-table :columns="columns" :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false"
			:indentSize="25" :style="{ background: '#FFF' }" size="small" row-key="planId" border :loading="loading"
			:data-source="data.records">
			<!-- 标题 -->
			<template slot-scope="row" slot="rowtitle">
				<a @click="$refs.detail.show(row)">{{ row.title }}</a>
			</template>
			<!-- 完成百分比 -->
			<template slot-scope="row" slot="process">
				<Progress :percent="row.process"></Progress>
			</template>
			<!--操作-->
			<template slot-scope="row" slot="action">
				<a-button-group shape="circle" size="small">
					<a-tooltip v-if="row.is" title="添加计划日志"><a-button @click="$refs.logs._show(row)" type="link"
							icon="plus"></a-button></a-tooltip>
				</a-button-group>
				<a-button-group shape="circle" size="small">
					<a-tooltip title="查看领导批注"><a-button type="link" icon="solution"
							@click="$refs.comment._show(row)"></a-button></a-tooltip>
				</a-button-group>
			</template>
		</a-table>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
					@showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>
		<add-form ref="addForm" @success="doRefresh"></add-form>
		<comment-list ref="comment"></comment-list>
		<logsList ref="logs" @success="doRefresh"></logsList>
		<detail ref="detail"></detail>
	</div>
</template>

<script>
import apiUtil from '@/common/apiUtil';

import utils from '@/common/utils';
import commentList from './components/commentList.vue';
import addForm from './components/addForm.vue';
import detail from './components/detail.vue';
import logsList from './components/logsList.vue';

import Progress from './components/progress.vue';
export default {
	components: { addForm, detail, commentList, logsList, Progress },
	data() {
		return {
			data: {},
			loading: false,
			organList: apiUtil.getOrganList(),
			pageSize: 10,
			total: '',
			staffId: apiUtil.getUser().staffId,
			param: {
				current: 1,
				limit: 20,
				keyword: '',
				status: '',
				organId: apiUtil.getOrganId(''),
			},
			columns: [
				{ title: '计划名称', scopedSlots: { customRender: 'rowtitle' }, align: 'left' },
				{ title: '发布人', dataIndex: 'staffName', width: 100, resizable: true },
				{ title: '开始时间', dataIndex: 'startDate', width: 160, resizable: true, align: 'center' },
				{ title: '结束时间', dataIndex: 'overDate', width: 160, resizable: true, align: 'center' },
				{ title: '计划类别', dataIndex: 'categoryName', width: 160, resizable: true, align: 'center' },
				{ title: '负责人', dataIndex: 'managerName', width: 200, resizable: true, align: 'center' },
				{ title: '完成进度', scopedSlots: { customRender: 'process' }, width: 100, resizable: true, align: 'center' },
				{ title: '状态', dataIndex: 'status', width: 160, ellipsis: true, align: 'center' },
				{ title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 100 }
			]
		};
	},
	mounted() {
		this.getList();
	},
	methods: {
		...apiUtil,
		// 获取数据
		getList() {
			this.loading = true;
			this.http
				.get('/platform/work-plan/query', this.param)
				.then(ret => {
					ret.data.records.forEach(item => {
						if (item.staffId == this.staffId) {
							item.is = true;
						} else if (item.scopeStaffIds.find(sta => sta == this.staffId) != undefined) {
							item.is = true;
						} else if (item.scopeMasterIds.find(sta => sta == this.masterId) != undefined) {
							item.is = true;
						} else {
							item.is = false;
						}
					});
					this.data = ret.data;
					// console.log(this.data.records);
					this.total = data.total;
					this.param.current = data.current;
					this.loading = false;
				})
				.catch(err => {
					this.loading = false;
				});
		},
		change(e) {
			if (e.target.value == '') {
				this.getList();
			}
		},
		// 删除
		del(id) {
			this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
				utils.showSpin();
				this.http.delete('/platform/work-report/del/' + id).then(ret => {
					if (ret.code == 200) {
						this.utils.success('操作成功！').then(() => {
							this.getList();
						});
					}
				});
			});
		},
		// 筛选条件变化重新获取数据
		doRefresh() {
			this.param.current = 1;
			this.getList();
		},

		// 筛选单位
		filterOrgan(e) {
			this.param.organId = e;
		},
		//设置每页的显示条数
		setLimit(current, limit) {
			this.param.page = 1;
			this.param.limit = limit;
			this.getList();
		},
		//页码切换
		getNext(page) {
			this.param.page = page;
			this.getList();
		}
	}
};
</script>

<style></style>
